import React from "react";
import "../EventGallery.css";

const DayOne2024 = () => {
  const images = [
    "https://cloud.hoverbusinessservices.com/aiifa/media/past-events/2024/day1-2024/1.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/2.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/3.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/4.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/5.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/6.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/7.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/8.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/9.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/10.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/11.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/12.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/13.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/14.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/15.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/16.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/17.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/18.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/19.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/20.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/21.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/22.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/23.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/24.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/25.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/26.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/27.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/28.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/29.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/30.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/31.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/32.jpg",
    "http://hoverbusinessservices.com/cloud/aiifa/media/past-events/2024/day1-2024/33.jpg",
    
  ];

  return (
    <div className="event-gallery-container">
      <h2 className="event-gallery-title">Event 2024 Day 1</h2>
      <div className="event-gallery-grid">
        {images.map((img, index) => (
          <div key={index} className="event-gallery-card">
            <img src={img} alt={`Event ${index + 1}`} />
          </div> 
        ))}
      </div>
    </div>
  );
};

export default DayOne2024;